module.exports = __webpack_public_path__ + "static/media/img100.9c643a25.jpg";